import React from 'react';



import { Link } from "react-router-dom";
//import '../App.css';


import tabla from 'assets/img/tabla.png';
import config from 'assets/img/config.png';
import pdficon from 'assets/img/pdficon.png';


const MenuDebug = () => {
    return (
      <div >

        <div className="container pt-4">

          <h4 style={{ color: "grey" }}><i className="fa fa-hand-up"></i>Menu debug</h4>

          <table class='table table-striped table-hover' width='100%' align='center'>
            <tbody>
              <tr >
                <th>operacion</th>
                <th>descrip</th>

              </tr>
              <tr >
                {/*<!-- borra la programacion de estudiantes en un curso entero-->*/}
                <td><a href="{{route('debug_bp_curso.index')}}"
                  class='btn btn-warning btn-sm' data-id='' > Eliminar programacion de un curso </a>
                </td>

                <td>Elimina registros en tabla programacion, de un curso entero</td>
              </tr>
              <tr >
                {/*<!--  borra estudiantes -->*/}
                <td><Link to="/reset_pass_est"
                  class='btn btn-danger btn-sm' data-id='' > Reset Pass Est.</Link>
                </td>

                <td>Reseteo de claves de estudiante, username=CI clave=CI </td>
              </tr>

              <tr >
                {/*<!-- borra la programacion de estudiantes en un curso entero-->*/}
                <td><a href="{{route('debug_bp.index')}}"
                  class='btn btn-warning btn-sm' data-id='' > Borra programacion de materia </a>
                </td>

                <td>Elimina registros en tabla programacion, de una materia determinada</td>
              </tr>
              <tr >
                {/*<!-- borra la programacion de estudiantes en un curso entero-->*/}
                <td><Link to="/reset"
                  class='btn btn-warning btn-sm' data-id='' > Reset sistema </Link>
                </td>

                <td>Elimina los registros de todas las tablas</td>
              </tr>

              <tr >
                <td><a href="{{route('materiaa_crud.corregir_materia_nom2')}}"
                  class='btn btn-warning btn-sm' data-id='' > Corregir tabla materia </a>
                </td>

                <td>Para cada registro en Materia_nom, buscamos en materia, si existe, actualizamos sigla, nombre_mat   </td>
              </tr>
              <tr >
                <td><a href="{{route('materiaa_crud.corregir_materia_nom2')}}"
                  class='btn btn-warning btn-sm' data-id='' > Backup de estructura Mysql  </a>
                </td>
                <td>Saca una copia de tablas y campos   </td>
              </tr>
              <tr >
                <td><a href="{{route('materiaa_crud.corregir_materia_nom2')}}"
                  class='btn btn-warning btn-sm' data-id='' > Comparador de estructuras Mysql</a>
                </td>
                <td>Comparador con la estructura actual   </td>
              </tr>
              <tr >
                <td><a href="{{route('debug_bp_corrige_grupo.index')}}"
                  class='btn btn-secondary btn-sm' data-id='' > Cambiar grupo/categoria</a>
                </td>
                <td>cambia de grupo a nivel de curso/categoria</td>
              </tr>

              <tr >
                <td><Link to="/debug_compare_db"
                        class='btn btn-secondary btn-sm' >Comparador de DB</Link>
                </td>
                <td>comparador de base de datos</td>
              </tr>
              <tr >
                <td><a href="{{route('debug_corrige_acentos.index')}}"
                  class='btn btn-info btn-sm' data-id='' > Corrige las Ñ en nombres de estudiantes</a>
                </td>
                <td>corrige Ñ en nombres de estudiantes, despues de importar de csv</td>
              </tr>
              <tr >
                <td><a href="{{route('debug_corrige_id_mate_act.index')}}"
                  class='btn btn-info btn-sm' data-id='' > une tabla docente a tabla estudiante</a>
                </td>
                <td>une tabla docente a tabla estudiante </td>
              </tr>

              <tr >
                <td><a href="{{route('debug_corrige_fotosize.index')}}"
                  class='btn btn-danger btn-sm' data-id='' > Corrige fotos grandes 3096 ancho a 800 ancho</a>
                </td>
                <td>corrige fotos grandes de tabla tareas</td>
              </tr>

              <tr >
                <td><a href="{{route('debug_corrige_ajenas.index')}}"
                  class='btn btn-danger btn-sm' data-id='' > Muestra claves ajenas </a>
                </td>
                <td>Muestra claves ajenas que no estan relacionadas</td>
              </tr>

              <tr >
                <td><a href="{{route('debug.corrige_id_mate')}}"
                  class='btn btn-warning btn-sm' data-id='' > Corrige id_mate en tareas_est </a>
                </td>
                <td></td>
              </tr>


            </tbody>
          </table>

        </div>
      </div>
    );
}

export default MenuDebug;